import { defineComponent as w, useCssModule as C, computed as r, createElementBlock as b, openBlock as v, normalizeClass as s, unref as e, createElementVNode as a, renderSlot as y, createVNode as n } from "vue";
import V from "../../utils/propValidator.mjs";
import { buildBooleanClass as k } from "../../utils/buildClass.mjs";
import z from "../icon/comps/check-sm.vue.mjs";
import B from "../icon/comps/x-sm.vue.mjs";
import S from "../../utils/mapClasses.mjs";
import $ from "../../utils/uid.mjs";
const g = ["id"], W = ["aria-checked", "aria-labelledby"], u = "cdr-switch", j = /* @__PURE__ */ w({
  name: "CdrSwitch",
  __name: "CdrSwitch",
  props: {
    /**
     * Sets a custom ID for the switch. If this value is not set, it will be auto-generated.
    */
    id: {
      type: String
    },
    /**
     * Sets the size of the switch
     * @demoSelectMultiple false
     * @values medium, large
    */
    size: {
      type: String,
      default: "medium",
      validator: (i) => V(i, ["medium", "large"])
    },
    /**
     * Sets the label and switch to expand to the full width of its container with `space-between`
     */
    fullWidth: {
      type: Boolean,
      default: !1
    },
    /**
     * @demoIgnore true
    */
    modelValue: {
      type: Boolean,
      required: !0
    }
  },
  emits: {
    /**
     * Event emitted by v-model on switch
     * @param modelValue
     */
    "update:modelValue": null
  },
  setup(i, {
    emit: m
  }) {
    const t = i, f = m, l = C(), d = t.id ? t.id : $(), h = (o) => {
      f("update:modelValue", !o);
    }, p = r(() => t.size ? `cdr-switch--${t.size}` : "cdr-switch--medium"), _ = r(() => t.fullWidth ? k(u, t.fullWidth, "full-width") : "");
    return (o, c) => (v(), b("div", {
      class: s(e(S)(e(l), u, _.value, p.value))
    }, [a("div", {
      id: e(d),
      class: s(e(l)["cdr-switch__label"])
    }, [y(o.$slots, "default")], 10, g), a("button", {
      onClick: c[0] || (c[0] = (q) => h(i.modelValue)),
      class: s(e(l)["cdr-switch__button"]),
      role: "switch",
      "aria-checked": i.modelValue,
      "aria-labelledby": e(d)
    }, [n(z, {
      class: s(e(l)["cdr-switch__button-icon"])
    }, null, 8, ["class"]), n(B, {
      class: s(e(l)["cdr-switch__button-icon"])
    }, null, 8, ["class"]), a("div", {
      class: s(e(l)["cdr-switch__handle"])
    }, null, 2)], 10, W)], 2));
  }
});
export {
  j as default
};
